import { httpGet, httpPost } from '../../api/httpClient';
import { AuthToken, CurrentUser, LoginRequest } from '../../api/types';

export const authApi = {
  login(payload: LoginRequest): Promise<AuthToken> {
    return httpPost<AuthToken, LoginRequest>('/v1/auth/login', payload);
  },

  me(): Promise<CurrentUser> {
    return httpGet<CurrentUser>('/v1/auth/me');
  },

  logout(): Promise<void> {
    return httpPost<void>('/v1/auth/logout');
  },
};
